import WebClient, { constants } from 'utils/webclient'
import { store, setBasket, addToBasket, removeFromBasket } from 'utils/redux-store'
import * as rdd from 'react-device-detect';

export async function GetHospitalListForSelect(value = "id") {

    let languageId = store.getState().languageId;
    if (languageId == undefined) {
        languageId = 1;
    }
    let list = []
    let client = new WebClient()
    let a = await client.post("573D6FBC30D637/HospitalList", {}, true)
    if (a?.data)
        list = a.data

    let b = list.map((e) => {
        const resource = e.resources.find(x => x.languageId == languageId);
        const label = resource ? resource.name : '';
        return {
            value: value === "code" ? e.code : e.id,
            label: label
        };
    });

    return b
}

export async function FilterHospitalsByAppointmentType({ appointmentTypeId = 0, departmentId = 0, doctorId = 0, hospitalPackageGradeId = 0, hospitalServiceExternalId = 0, insuranceId = 0, departmentCode = "" }) {

    let list = []
    let client = new WebClient()
    let a = await client.post("573D6FBC30D637/FilterHospitals", {
        departmentCode,
        doctorId,
        departmentId,
        appointmentTypeId,
        page: 0,
        pageSize: 0,
        search: "",
        hospitalPackageGradeId,
        hospitalServiceExternalId,
        insuranceId
    }, true)
    if (a?.data)
        list = a?.data.map((e) => {
            return {
                ...e,
                name: e.resource?.name ?? "",
                logo: e.resource?.logo ?? "",
                value: e.id,
                label: e.resource?.name ?? ""
            }
        })

    return list
}

export async function FilterDepartments({ appointmentTypeId = 0, hospitalId = 0, doctorId = 0, hospitalPackageGradeId = 0, hospitalServiceExternalId = 0, enableCheckSpecialDoctor = false }) {

    let list = []
    let client = new WebClient()
    let a = await client.post("573D6FBC30D637/FilterDepartments", {
        doctorId,
        hospitalId,
        appointmentTypeId,
        page: 0,
        pageSize: 0,
        search: "",
        hospitalPackageGradeId,
        hospitalServiceExternalId,
        enableCheckSpecialDoctor
    }, true)
    if (a?.data)
        list = a?.data.map((e) => {
            return {
                ...e,
                name: e.resource?.name ?? "",
                logo: e.resource?.logo ?? "",
                value: e.id,
                label: e.resource?.name ?? ""
            }
        })

    return list
}

export async function GetDepartmentList(hospitalId, getSingularDepartments = true) {

    let list = []
    let client = new WebClient()
    let a = await client.post("573D6FBC30D637/DepartmentList", {
        hospitalId,
        getSingularDepartments
    }, true)
    if (a?.data)
        list = a?.data.map((e) => {
            return {
                ...e,
                name: e.resource.name,
                value: e.id,
                label: e.resource.name,
            }
        })

    return list
}

export async function GetHospitalDepartmentListForSelect(hospitalId) {
    let list = []
    let client = new WebClient()
    let a = await client.post("573D6FBC30D637/DepartmentList", {
        hospitalId,
        getSingularDepartments: false
    })
    if (a?.data)
        list = a.data

    const b = list.map((e) => {
        return {
            value: e.id,
            label: e.resource.name
        }
    })

    return b
}
export async function GetGenderForSelect() {
    let list = []
    let client = new WebClient()
    let a = await client.post("573D6FBC30D637/GenderList", {})
    if (a?.data)
        list = a.data

    const b = list.map((e) => { return { value: e.id, label: e.name } })
    return b
}

export class BasketService {
    client = new WebClient();

    member = store.getState().member

    languageId = store.getState().languageId;
    patientId = this.member?.profileId != this.member?.patientId ? this.member?.profileId : this.member?.patientId

    async getBasketCount() {
        const response = await this.client.post('563371BA3ACC37/Count', {}, true);
        const { isSuccess, data, exception } = response;

        return response;
    }

    async getItems() {
        const response = await this.client.post('563371BA3ACC37/Items', {}, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
            setBasket(data);
        } else {
            setBasket({})
        }
        return response;
    }

    async addItem(productId, quantity, productType, isSubcription = false) {
        const response = await this.client.post('563371BA3ACC37/AddItem', {
            productId,
            productType, // package: 1, device: 2, appointment: 3, upgrade: 4
            quantity,
            isSubcription
        }, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
            addToBasket(quantity);
        }
        return response;
    }

    async removeItem(productId, productType) {
        const response = await this.client.post('563371BA3ACC37/RemoveItem', {
            productId,
            productType
        }, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
            removeFromBasket({ productId, productType });
        }
        return response;
    }

    async removeBasket() {
        const response = await this.client.post('563371BA3ACC37/Remove', {}, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
            this.getItems()
        }
        return response;
    }
}

export class PaymentService {
    #client = new WebClient();
    languageId = store.getState().languageId;
    patientId = store.getState().patient.id;

    async getInstallmentInfo({ binNumber, amount, basketItemId, productType, currencyId }) {
        const response = await this.#client.post('44337BBC3AD660/BinInquiry', {
            binNumber: binNumber.split(' ').join(''),
            amount: amount.toString(),
            basketItemId,
            productType,
            currencyId
        }, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async createPatientPayment({
        hospitalId,
        addressId,
        billingId,
        productId,
        productType,
        cardNumber,
        cardHolderName,
        year,
        month,
        cvc,
        installment,
        amount,
        basketItemId,
        cardAlias,
        saveCard,
        cardToken,
        cardUserKey,
        payWithRegisteredCard
    }) {
        const response = await this.#client.post('44337BBC3AD660/PatientPaymentCreating', {
            clientIp: '',
            hospitalId,
            addressId,
            billingId,
            productId,
            productType,
            cardHolderName,
            year,
            month,
            cvc,
            installment,
            amount: amount.toString(),
            cardNumber: cardNumber.split(' ').join(''),
            basketItemId,
            cardAlias,
            saveCard,
            cardToken,
            cardUserKey,
            payWithRegisteredCard
        }, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async sendSurveyIdByOrderId({ orderId }) {
        console.log("sendSurveyIdByOrderId-->", orderId)
        const response = await this.#client.post('472770A73AC137/SendSurveyIdByOrderId', { orderId }, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async storeCards() {
        const response = await this.#client.post('44337BBC3AD660/PatientStoredCard', {}, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async deleteStoreCard(cardToken, cardUserKey) {
        const response = await this.#client.post('44337BBC3AD660/DeleteStoreCard', { cardToken, cardUserKey }, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async fetchPatientOrderDetail({ productId, productType, basketItemId = 0 }) {
        const response = await this.#client.post('44337BBC3AD660/PatientOrderDetail', { productId, productType, basketItemId }, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }
}

export class PackageService {
    #client = new WebClient();
    languageId = store.getState().languageId;
    patientId = store.getState().patient.id;

    async comparePlans({ packageGradeIds }) {
        const response = await this.#client.post(
            '443361BA3EDF71/ComparePlans',
            {
                packageGradeIds,
            },
            false,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getPackageDetail({ packageId }) {
        const response = await this.#client.post(
            '443361BA3EDF71/GetPackageDetail',
            {
                packageId,
            },
            false,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getPackageGradeDetail({ packageGradeId }) {
        const response = await this.#client.post(
            '443361BA3EDF71/GetPackageGradeDetail',
            {
                packageGradeId,
            },
            false,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getPatientPackageDetail({ purchaseId }) {
        const response = await this.#client.post(
            '443376B83AD66026899B7939A56A31BD5C1396B26875/GetPatientPackageDetail',
            { purchaseId },
            true,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getPatientActivePackages(onlyListLoyaltyCardRelated = false) {
        const response = await this.#client.post(
            '443376B83AD66026899B7939A56A31BD5C1396B26875/GetPatientActivePackages',
            { onlyListLoyaltyCardRelated },
            true,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getOtherPeopleInThePackage({ purchaseId }) {
        const response = await this.#client.post(
            '443376B83AD66026899B7939A56A31BD5C1396B26875/GetOtherPeopleInThePackage',
            { purchaseId },
            true,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async verifyForAddPeopleToPackage({ smsCode, key }) {
        const response = await this.#client.post(
            '443376B83AD66026899B7939A56A31BD5C1396B26875/VerifyForAddPeopleToPackage',
            { smsCode, key },
            true,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async addPeopleToPackage({ purchaseId, tcIdentityNumber, passportNumber, birthdate, relationType, verificationCodeReceiveType = 1 }) {
        const response = await this.#client.post(
            '443376B83AD66026899B7939A56A31BD5C1396B26875/AddPeopleToPackage',
            { purchaseId, protocolNo: '', tcIdentityNumber, passportNumber, birthdate, relationType, verificationCodeReceiveType },
            true,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async addPeopleToPackageByRegisteringPatient({
        purchaseId,
        name,
        surname,
        genderShortCode,
        nationalityCode,
        tcIdentityNumber,
        passportNumber,
        phone,
        eMail,
        birthdate,
        relationType,
        verificationCodeReceiveType = 1
    }) {
        const response = await this.#client.post(
            '443376B83AD66026899B7939A56A31BD5C1396B26875/AddPeopleToPackageByRegisteringPatient',
            {
                purchaseId,
                protocolNo: '',
                name,
                surname,
                genderShortCode,
                nationalityCode,
                tcIdentityNumber,
                passportNumber,
                phone,
                eMail,
                birthdate,
                relationType,
                verificationCodeReceiveType
            },
            true,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async removePeopleToPackage({ relationId }) {
        const response = await this.#client.post(
            '443376B83AD66026899B7939A56A31BD5C1396B26875/RemovePeopleToPackage',
            relationId,
            true,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async checkUpRequest({ hospitalPackageGradeId, hospitalServiceExternalId }) {
        const response = await this.#client.post(
            '443376B83AD660/CheckUp/CallRequest',
            { hospitalPackageGradeId, hospitalServiceExternalId },
            true,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async subscriptionCancellation({ purchaseId, information }) {
        const response = await this.#client.post(
            '443376B83AD66026899B7939A56A31BD5C1396B26875/SubscriptionCancellation',
            { purchaseId, information },
            true,
            false,
            false
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }
}

export class OfficialDocumentService {
    #client = new WebClient();
    #patientId = store.getState().patient?.id
    languageId = store.getState().languageId;
    applicationId = constants.applicationId;

    async filter({ categoryId, appointmentExternalId, appointmentId, addressId, productId, productType }) {
        const response = await this.#client.post('5B3464B83CD17502A2876A25BC6E3399/Filter', {
            categoryId,
            applicationId: this.applicationId
        });
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getCategoryList() {
        const response = await this.#client.post('5B3464B83CD17502A2876A25BC6E3399/DocumentCategoryList', {});
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }
}

export class OfficialDocumentServiceForPatient {
    #client = new WebClient();
    #patientId = store.getState().patient?.id
    languageId = store.getState().languageId;
    applicationId = constants.applicationId;

    async filter({ categoryId, appointmentExternalId, appointmentId, addressId, productId, productType }) {
        const response = await this.#client.post('5B3464B83CD17502A2876A25BC6E3399/PatientFilter', {
            categoryId,
            applicationId: this.applicationId,
            appointmentExternalId,
            appointmentId,
            addressId,
            productId,
            productType
        }, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }
}

export class NotificationService {
    #client = new WebClient();
    #applicationId = constants.applicationId;
    #patientId = store.getState().patient.id;
    #user = rdd.useDeviceData();

    async registerDevice({ playerId, isPermissionGranted }) {
        const response = await this.#client.post('573D6FBC30D637/RegisterDevice', {
            id: undefined,
            uniqueId: undefined,
            playerId,
            brand: this.#user?.device?.vendor,
            model: this.#user?.device?.model,
            osversion: this.#user?.os?.version,
            type: this.#user?.device?.type || this.#user?.os?.name,
            platform: this.#user?.browser?.name,
            patientId: this.#patientId,
            hasNotificationPermission: isPermissionGranted,
            isEmailSubscribed: undefined,
            isPushDisabled: undefined,
            isSmssubscribed: undefined,
            isSubscribed: isPermissionGranted,
            pushToken: undefined,
            registerDeviceApplications: [
                {
                    applicationId: this.#applicationId,
                    appVersion: undefined,
                    buildNumber: undefined,
                    isActive: isPermissionGranted,
                },
            ],
        });
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async listNotifications({ playerId }) {
        const response = await this.#client.post(
            '5A3D76B839D1770F9281663E/List',
            {
                playerId,
            },
            true
        );
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getNotificationCount() {
        console.log("getNotificationCount")
        const response = await this.#client.post('5A3D76B839D1770F9281663E/Count', {}, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }
}
export class LoyaltyService {
    #client = new WebClient();

    async patientCardInformation() {
        const response = await this.#client.post('583D7BB033CC6D2D879A6D/PatientCardInformation', {}, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getCardTypeList() {
        const response = await this.#client.post('583D7BB033CC6D2D879A6D/CardTypeList', {}, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getAdvantages(cardTypeDetailId) {
        const response = await this.#client.post('583D7BB033CC6D2D879A6D/AdvantageList', { cardTypeDetailId }, false);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getPointHistory() {
        const response = await this.#client.post('583D7BB033CC6D2D879A6D/PatientCardPointsHistory', {}, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getFaq(visibilityStatus = 1) {
        const response = await this.#client.post('512A76B42DD67502/Faq', {
            visibilityStatus: visibilityStatus,
            filterOption: 2,
        }, false);

        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getContentList(pageTypes) {
        const response = await this.#client.post('583D7BB033CC6D2D879A6D/ContentList', {
            pageTypes: pageTypes
        }, false);

        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }

    async getContentPage(pageType) {
        const response = await this.#client.post('583D7BB033CC6D2D879A6D/ContentPage', {
            pageType: pageType
        }, false);

        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }


    async getMembershipSettings(PatientCardId) {
        const response = await this.#client.post('583D7BB033CC6D2D879A6D/MembershipSettings', { PatientCardId }, true);
        const { isSuccess, data, exception } = response;

        if (isSuccess) {
        }
        return response;
    }
}

export async function getEnumType(enumType) {
    let list = []
    let client = new WebClient()
    let a = await client.post("573D6FBC30D637/EnumList", {
        name: enumType
    })
    if (a?.data) list = a.data
    /*   const b = list.map((e) => { return { value: e.value, label: e.text } }) */
    return list
}

export class OtherService {
  #client = new WebClient();

  async sendSymptomCheckerMessage({
    messages = [],
    appointmentTypeId = 0,
    hospitalId = 0,
    doctorId = 0,
    hospitalPackageGradeId = 0,
    hospitalServiceExternalId = 0,
    enableCheckSpecialDoctor = true,
  }) {
    const response = await this.#client.post(
      '472B6FA12BD7792D8E8D6A3BB479/SendMessage',
      {
        messages,
        appointmentTypeId: appointmentTypeId || 0,
        hospitalId: hospitalId || 0,
        doctorId: doctorId || 0,
        hospitalPackageGradeId: hospitalPackageGradeId || 0,
        hospitalServiceExternalId: hospitalServiceExternalId || 0,
        enableCheckSpecialDoctor,
      },
      true
    );
    const { isSuccess, data, exception } = response;

    if (isSuccess) {
    }
    return response;
  }
}